import { render, staticRenderFns } from "./DrawerNetIncome.vue?vue&type=template&id=6a48ff95"
import script from "./DrawerNetIncome.vue?vue&type=script&lang=js"
export * from "./DrawerNetIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports